// Validation and neutral messaging for the public "Join the family" request.
// Limits mirror the server contract (POST /v1/iam/signup-requests); the server remains authoritative.
export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 1024;
export const NAME_MAX = 120;
export const LOGIN_MIN = 3;
export const LOGIN_MAX = 32;
export const USERNAME_PATTERN = /^[A-Za-z0-9_-]{3,32}$/;

const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateJoin({ name = "", username = "", email = "", password = "", confirm = "" } = {}) {
  const errors = {};
  const cleanName = String(name).trim();
  const cleanUsername = String(username);
  const cleanEmail = String(email).trim();
  if (!cleanName) errors.name = "Please tell us your name.";
  else if (cleanName.length > NAME_MAX) errors.name = "That name is a little too long.";
  if (!USERNAME_PATTERN.test(cleanUsername)) errors.username = "Use 3–32 ASCII letters, numbers, underscores, or hyphens.";
  if (!EMAIL_SHAPE.test(cleanEmail) || cleanEmail.length > 254) errors.email = "Please enter a valid email address.";
  if (String(password).length < PASSWORD_MIN) errors.password = `Use at least ${PASSWORD_MIN} characters.`;
  else if (String(password).length > PASSWORD_MAX) errors.password = "That password is too long.";
  if (!errors.password && password !== confirm) errors.confirm = "The two passwords do not match.";
  return errors;
}

export function buildSignupPayload({ name, username, email, password }) {
  return {
    login: String(username),
    display_name: String(name).trim(),
    password,
  };
}

// Never confirm or deny whether an account or pending request already exists.
export function describeSignupFailure(status) {
  if (status === 400) return "Please check your details and try again.";
  if (status === 429) return "Too many attempts. Please wait a moment and try again.";
  if (status === 503) return "Joining is temporarily unavailable. Please try again soon.";
  return "We couldn't submit your request. If you already have an account or a request in review, please sign in or wait for the Studio team to be in touch.";
}

export const JOIN_SUCCESS = {
  title: "Thank you. We have your request.",
  body: "The Studio team will review it before access is enabled. We will be in touch.",
};
